import {useCallback} from 'react';

import {useMcpTemporaryLimits} from 'src/components/connector-limits-form';
import {
    getAccountTempLimits,
    removeAccountTemporaryLimit,
    saveAccountTemporaryLimit,
} from 'src/openapi/admin/apis/AccountTemporaryLimitsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {TempLimit} from 'src/openapi/admin/models/TempLimit';

type Props = {
    accountId: number,
};

export const useAccountMcpTemporaryLimits = (
    {accountId}: Props,
) => {
    const apiDispatch = useAppDispatch();

    const getTempLimits = useCallback(
        (signal: AbortSignal) => apiDispatch(
            getAccountTempLimits({accountId}, {signal}),
        ),
        [accountId, apiDispatch],
    );

    const saveTempLimit = useCallback(
        (
            limits: TempLimit[],
            expiresOn: string,
            signal: AbortSignal,
        ) => apiDispatch(
            saveAccountTemporaryLimit(
                {accountId, limit: limits, expiresOn},
                {signal},
            ),
        ),
        [accountId, apiDispatch],
    );

    const removeTempLimit = useCallback(
        (
            limitIds: string[],
            signal: AbortSignal,
        ) => apiDispatch(
            removeAccountTemporaryLimit(
                {accountId, requestBody: limitIds},
                {signal},
            ),
        ),
        [accountId, apiDispatch],
    );

    return useMcpTemporaryLimits({
        getTempLimits,
        saveTempLimit,
        removeTempLimit,
    });
};
